export enum AssessmentCriteriaStatus {
  NotYetCompetent = 10,
  Competent = 20,
  Excellent = 30,
}
